import { getMonth, getWeekDay } from "../../dates";

const MS_PER_DAY = 1000 * 60 * 60 * 24;

function plural(count: number, singular: string, plural: string): string {
    if (Math.abs(count) < 2) return singular;

    return plural;
}

export default function LastCooked({ today, date }: { today: Date; date?: string }) {
    if (!date) {
        return <span className="recipe-last-cook never">Aldrig</span>;
    }

    const d = new Date(date);
    const title = `${getWeekDay(d)} ${d.getDate()} ${getMonth(d)}`;
    const diff = Math.round((today.getTime() - d.getTime()) / MS_PER_DAY);
    const days = plural(diff, "dag", "dagar");
    if (diff < 0) {
        // It is planned in the future
        return (
            <span className="recipe-last-cook future" title={title}>
                om {-diff} {days}
            </span>
        );
    }

    if (diff < 7) {
        return (
            <span className="recipe-last-cook recent" title={title}>
                {diff} {days} sen
            </span>
        );
    }

    const weeks = Math.floor(diff / 7);
    return (
        <span className="recipe-last-cook past" title={title}>
            {weeks} {plural(weeks, "vecka", "veckor")} sen
        </span>
    );
}
